import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Marquee } from '../components/Marquee';
import { GameCard, type GameMeta } from '../components/GameCard';
import { QUIZZES, difficultyLabel } from '../data/quizzes';

const GAMES: GameMeta[] = [
  {
    num: '№ 01',
    title: 'Мафия',
    desc: 'Дон, шериф, мирные. Кто-то врёт, кто-то умрёт. Классика, без которой не обходится ни один вечер.',
    info: '8–14 игроков · 30 мин',
    to: '/play/mafia',
    featured: true,
    badge: 'В топе',
  },
  { num: '№ 02', title: 'Alias', desc: 'Объясни слово — не назвав его. Команды на скорость.', info: '4+ · 20 мин', to: '/play/alias' },
  { num: '№ 03', title: 'Заяц', desc: 'Секретное слово знают все, кроме одного. Ассоциации, блеф и голосование.', info: '3–12 · 20 мин', to: '/play/zayac' },
  { num: '№ 04', title: 'Крокодил', desc: 'Покажи без слов. Угадай за 60 секунд.', info: '4+ · 25 мин', to: '/play/crocodile' },
  { num: '№ 05', title: 'Бункер', desc: 'Кого пустим внутрь, когда наверху апокалипсис?', info: '6–12 · 45 мин', to: '/play/bunker' },
  { num: '№ 06', title: 'Имаджинариум', desc: 'Ассоциативные карточки. Странно и красиво.', info: '4–7 · 30 мин', to: '/play/imaginarium' },
];

const QUIZ_PREVIEWS = QUIZZES.slice(0, 5).map((q, i) => ({
  n: String(i + 1).padStart(2, '0'),
  id: q.id,
  emoji: q.emoji,
  name: q.title,
  q: `${q.questions.length} вопросов`,
  d: difficultyLabel(q.difficulty, 'ru'),
}));

const ROOMS = [
  { name: '«у Вани»', game: 'Мафия', count: '7/10' },
  { name: '«мокрые мыши»', game: 'Alias', count: '4/8' },
  { name: '«дзен»', game: 'Бункер', count: '5/12' },
  { name: '«без злых»', game: 'Заяц', count: '3/6' },
];

export function Home() {
  return (
    <>
      <Header online={6412} />
      <HomeStyles />
      <section className="hero">
        <div className="container">
          <div className="meta">
            <span className="label">Выпуск 047 · пятница · 22:48</span>
            <span className="label">Вечериночные игры · онлайн и оффлайн</span>
          </div>
          <h1>
            Игры на один <span className="accent-word">вечер</span> —<br />и до утра.
          </h1>
          <div className="below">
            <p>
              Создай комнату за минуту, кинь ссылку в чат — и понеслось. Мафия, Alias, Заяц, Бункер, квизы и ещё
              23 игры, в которые играют прямо сейчас.
            </p>
            <div className="cta">
              <a href="/play" className="btn-primary lg">
                Начать игру →
              </a>
              <a href="/rooms" className="btn-ghost lg">
                Войти по коду
              </a>
            </div>
          </div>
        </div>
      </section>

      <Marquee />

      <section className="block" id="catalog">
        <div className="container">
          <div className="sec-head">
            <div>
              <span className="label">/ 01 · Каталог</span>
              <h2>Во что играем</h2>
            </div>
            <div className="tabs">
              <span className="tab on">Все</span>
              <span className="tab">На вечеринку</span>
              <span className="tab">Квизы</span>
              <span className="tab">2 игрока</span>
              <span className="tab">10+</span>
            </div>
          </div>

          <div className="grid">
            {GAMES.map((g) => (
              <GameCard key={g.num} game={g} />
            ))}
            <div className="card more">
              <span className="display" style={{ fontSize: 26, color: 'var(--ink-dim)' }}>
                Ещё 23 игры
              </span>
              <span className="mono" style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink-faint)' }}>
                Весь каталог →
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="block" id="quizzes">
        <div className="container">
          <div className="two-col">
            <div>
              <div className="sec-head" style={{ marginBottom: 28 }}>
                <div>
                  <span className="label">/ 02 · Квизы</span>
                  <h2>Проверь эрудицию</h2>
                </div>
                <div className="sec-links">
                  <Link
                    to="/quizzes"
                    className="mono"
                    style={{ fontSize: 11, color: 'var(--ink-dim)', letterSpacing: '0.14em', textTransform: 'uppercase', textDecoration: 'none' }}
                  >
                    Все {QUIZZES.length} квизов →
                  </Link>
                  <Link
                    to="/quiz-live"
                    className="mono"
                    style={{ fontSize: 11, color: 'var(--accent)', letterSpacing: '0.14em', textTransform: 'uppercase', textDecoration: 'none' }}
                  >
                    🎮 Баттл с телефона →
                  </Link>
                </div>
              </div>
              <div className="quiz-list">
                {QUIZ_PREVIEWS.map((q) => (
                  <Link to={`/quiz/${q.id}`} className="quiz-row" key={q.n}>
                    <span className="n">{q.n}</span>
                    <span className="name">
                      {q.emoji} {q.name}
                    </span>
                    <span className="q">{q.q}</span>
                    <span className="d">{q.d}</span>
                    <span className="score">играть →</span>
                  </Link>
                ))}
              </div>
            </div>

            <div id="rooms">
              <div className="sec-head" style={{ marginBottom: 28 }}>
                <div>
                  <span className="label">/ 03 · Live</span>
                  <h2 style={{ fontSize: 52 }}>Зайди к своим</h2>
                </div>
              </div>
              <div className="rooms">
                <div className="head">
                  <span className="label">Открытые комнаты</span>
                  <span className="pill">
                    <span className="dot" />
                    18 комнат
                  </span>
                </div>
                {ROOMS.map((r) => (
                  <div className="room-row" key={r.name}>
                    <div>
                      <div className="rn">{r.name}</div>
                      <div className="rg">{r.game}</div>
                    </div>
                    <span className="rp">{r.count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="foot">
        <div className="container">
          <div className="foot-row">
            <span>© Шум.клуб · MMXXVI · всё разрешено, кроме скуки</span>
            <span>v.05.0</span>
          </div>
        </div>
      </footer>
    </>
  );
}

function HomeStyles() {
  return (
    <style>{`
      .hero { padding: 96px 0 72px; }
      .hero .meta { display: flex; justify-content: space-between; margin-bottom: 44px; }
      .hero h1 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 104px; line-height: 1.02; letter-spacing: -.015em; margin: 0; max-width: 1000px; }
      .hero .below { display: flex; justify-content: space-between; align-items: flex-end; gap: 48px; margin-top: 52px; }
      .hero .below p { max-width: 480px; font-size: 17px; line-height: 1.55; color: var(--ink-dim); margin: 0; }
      .hero .cta { display: flex; gap: 12px; align-items: center; flex-shrink: 0; }

      section.block { padding: 88px 0 0; }
      .sec-head { display: flex; justify-content: space-between; align-items: flex-end; gap: 32px; margin-bottom: 36px; }
      .sec-head h2 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 52px; line-height: 1; letter-spacing: -.01em; margin: 12px 0 0; }
      .tabs { display: flex; gap: 6px; flex-wrap: wrap; }
      .sec-links { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; }

      .grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
      .card.more { justify-content: center; align-items: center; background: transparent; border-style: dashed; text-align: center; gap: 10px; color: inherit; text-decoration: none; }

      .two-col { display: grid; grid-template-columns: 1.4fr 1fr; gap: 32px; }
      .quiz-list { border-top: 1px solid var(--line-strong); }
      .quiz-row { display: grid; grid-template-columns: 44px 1fr 130px 90px 100px; align-items: baseline; gap: 14px; padding: 18px 0; border-bottom: 1px solid var(--line); cursor: pointer; transition: background .2s; text-decoration: none; color: inherit; }
      .quiz-row:hover { background: var(--bg2); }
      .quiz-row .n { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: var(--ink-faint); }
      .quiz-row .name { font-family: 'Oswald', sans-serif; font-weight: 500; font-size: 26px; letter-spacing: -.005em; }
      .quiz-row .q, .quiz-row .d { font-family: 'JetBrains Mono', monospace; font-size: 11px; letter-spacing: .1em; text-transform: uppercase; color: var(--ink-dim); }
      .quiz-row .score { font-family: 'JetBrains Mono', monospace; font-size: 11px; letter-spacing: .08em; color: var(--ink-faint); text-align: right; }

      .rooms { background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card); padding: 28px; }
      .rooms .head { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 6px; }
      .rooms h3 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 32px; margin: 8px 0 14px; letter-spacing: -.005em; }
      .room-row { display: flex; justify-content: space-between; align-items: center; padding: 14px 0; border-bottom: 1px solid var(--line); }
      .room-row:last-child { border-bottom: 0; }
      .room-row .rn { font-size: 15px; font-weight: 500; }
      .room-row .rg { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--ink-faint); letter-spacing: .14em; text-transform: uppercase; margin-top: 4px; }
      .room-row .rp { font-family: 'JetBrains Mono', monospace; font-size: 13px; color: var(--ink-dim); }

      @media (max-width: 1160px) {
        .grid { grid-template-columns: repeat(2, 1fr); }
        .hero h1 { font-size: 80px; }
        .hero .below { flex-direction: column; align-items: flex-start; gap: 28px; }
      }
      @media (max-width: 1100px) { .two-col { grid-template-columns: 1fr; gap: 64px; } }
      @media (max-width: 720px) {
        .grid { grid-template-columns: 1fr; }
        .card.featured { grid-column: span 1; }
        .hero h1 { font-size: 56px; }
        .quiz-row { grid-template-columns: 44px 1fr 100px; grid-auto-rows: auto; }
        .quiz-row .q, .quiz-row .score { display: none; }
      }
    `}</style>
  );
}
